/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-06 18:47:57
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-25 13:15:18
 * @FilePath: \senlan-ai-ui\src\routers\modules\StaticRoutes.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Navigate } from 'react-router-dom'
import type { RouteItemType } from '../types/index.ts'
import { LOGIN_PATH } from '../../config/index.ts'
import LoginPage from '../../pages/login/index.tsx'
import Independent from '../../pages/Independent/index.tsx'
import RouterBefore from '../modules/RouterBefore.tsx'

// 配置静态路由表
const staticRoutes: RouteItemType[] = [
  {
    path: '/',
    element: <Navigate to={LOGIN_PATH} replace />,
  },
  {
    path: '/*',
    element: <Independent />,
  },
  {
    path: LOGIN_PATH,
    element: <LoginPage></LoginPage>,
    meta: {
      title: '登录',
    },
  },
]

export const publicRoutes = staticRoutes.map((route) => {
  return {
    ...route,
    element: <RouterBefore>{route.element}</RouterBefore>,
    loader: () => {
      return { ...route.meta }
    },
  }
})

export default publicRoutes
